import {map, tap} from 'rxjs/operators'; // Thêm tap
import {HttpResponse} from '@angular/common/http';
import {LoaiHoatDongService} from '@entities/loai-hoat-dong/loai-hoat-dong.service';
import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import {Observable} from 'rxjs';
import {ILoaiHoatDong} from '@entities/loai-hoat-dong/loai-hoat-dong.model';

@Injectable({
  providedIn: 'root',
})
export class LoaiHoatDongListResolver implements Resolve<any> {
  constructor(private service: LoaiHoatDongService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<ILoaiHoatDong[]> | Promise<ILoaiHoatDong[]> | ILoaiHoatDong[] {
    return this.service
      .getAll()
      .pipe(map((res: HttpResponse<ILoaiHoatDong[]>) => res.body));
  }
}
